import React, { Component } from 'react';
import { Container } from 'flux/utils';
import assign from 'object-assign';
import PropTypes from 'prop-types';

import DetailView from '../Common/DetailView';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import { getISODateLimits } from '../../utils/Date';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import EventWrapper from '../Event/EventWrapper';
import EventDialog from '../Event/EventDialog';
import EventDialogCreate from '../Event/EventDialogCreate';

import CalendarIcon from 'material-ui/svg-icons/action/date-range';
import EventIcon from 'material-ui/svg-icons/action/event';
import InfoIcon from 'material-ui/svg-icons/action/info';

import buildContextMenu from '../Common/BuildContextMenu';
import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';
import ModuleEventStore from '../../stores/ModuleEventStore';

import ROLES from '../../constants/Roles';

const localizer = BigCalendar.momentLocalizer(moment);

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const formats = {

};

class ModuleCalendar extends Component {

    componentWillMount() {
        const moduleId = Number(this.props.routeParams.id) || null;
        this.setState({
            moduleId,
            actions: buildContextMenu(this.getActions(moduleId)),
            dialog: {
                open: false,
                start: null,
                end: null,
                eventDates: null
            }
        });
    }

    componentDidMount() {
        this.onNavigate = this.onNavigate.bind(this);
        this.onDateSelect = this.onDateSelect.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.onEventFormSubmit = this.onEventFormSubmit.bind(this);
        this.moduleChange = this.moduleChange.bind(this);
        this.eventChange = this.eventChange.bind(this);
        this.convertEvent = this.convertEvent.bind(this);
        this.selectEvent = this.selectEvent.bind(this);

        if (!!this.state.moduleId) {
            ModuleActions.getById(this.state.moduleId);
            ModuleActions.getEvents(this.state.moduleId, {...getISODateLimits(), limit: 0});
        }
        this.listeners = [
            ModuleStore.addListener(this.moduleChange),
            ModuleEventStore.addListener(this.eventChange)
        ];
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    render() {
        const title = (this.state.module && this.state.module.name || 'Module');
        const { actions } = this.state;
        const canEdit = this.context.auth.isAdmin() && this.context.auth.canEdit(this.state.module.access);

        let colour = 'rgb(35, 151, 190)';
        let avatarIcon = (<CalendarIcon style={style.icon} color={colour}/>);
        const scrollToTime = new Date();
        scrollToTime.setHours(6);

        return (
            <DetailView
                title=''
                backButton={true}
                actions={actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title="Calendar"
                            subtitle={title}
                            avatar={avatarIcon}
                        />
                        <CardText className="cent-card-calendar">
                            <BigCalendar
                                localizer={localizer}
                                popup
                                popupOffset={20}
                                formats={formats}
                                views={['month', 'week', 'day']}
                                selectable={canEdit}
                                defaultView="month"
                                events={this.state.events}
                                eventPropGetter={this.eventPropGetter}
                                onNavigate={this.onNavigate}
                                onSelectSlot={this.onDateSelect}
                                components={{eventWrapper: EventWrapper}}
                                scrollToTime={scrollToTime}
                            />
                        </CardText>
                    </Card>
                </div>
                {this.state.dialog.open &&
                    <EventDialogCreate
                        title='New event'
                        nameRequired={false}
                        open
                        eventDates={this.state.dialog.eventDates}
                        start={this.state.dialog.start}
                        end={this.state.dialog.end}
                        onClose={this.onDialogClose}
                        onSave={this.onEventFormSubmit}
                    />
                }
                <EventDialog
                    event={this.state.selectedEvent}
                    onClose={() => this.selectEvent()}
                    editLink={(ROLES.ADMIN && this.state.selectedEvent && `/dashboard/event/${this.state.selectedEvent.id}/edit`) || null}
                />
                <ErrorSnackbar/>
            </DetailView>
        );
    }

    getActions(id) {
        if (!id) { return []; }
        return [
            {
                link: `/dashboard/module/${id}`,
                icon: <InfoIcon />,
                label: 'Preview',
            },
            {
                link: `/dashboard/module/${id}/events`,
                icon: <EventIcon />,
                label: 'Events'
            }
        ];
    }

    onNavigate(date, view) {
        ModuleActions.getEvents(this.state.moduleId, {...getISODateLimits(date, view), limit: 0});
    }

    eventPropGetter(event) {
        let prop = {};
        if (event.attendanceStatus !== null) {
            prop.className = 'cent-event-attendance';
        } else {
            prop.className = 'cent-event';
        }
        return prop;
    }

    onDateSelect(slotInfo) {
        const options = {weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'};
        const startDate = slotInfo.start.toLocaleString('en-GB', options).substring(0,11);
        const endDate = slotInfo.end.toLocaleString('en-GB', options).substring(0,11);

        let dialog = {};
        dialog.start = slotInfo.start;
        dialog.end = slotInfo.end;
        dialog.eventDates = startDate;
        if (startDate !== endDate) {
            dialog.eventDates = `${dialog.eventDates} - ${endDate}`;
        }
        dialog.open = true;

        this.setState({dialog});
    }

    onDialogClose() {
        this.setState({dialog: assign({}, this.state.dialog, {open: false})});
    }

    onEventFormSubmit(data) {
        data.timeStart = data.timeStart.toString().replace(/\s\([^)]+\)/, '');
        data.timeEnd = data.timeEnd.toString().replace(/\s\([^)]+\)/, '');
        data.description = '';
        data.periodic = false;

        ModuleActions.addEvent(this.state.moduleId, data);
        ModuleActions.getEvents(this.state.moduleId, {limit: 0});

        this.onDialogClose();
    }

    moduleChange() {
        const module = ModuleStore.getById(this.state.moduleId);
        if (module !== undefined) {
            this.setState({module});
            if (module.type === 'classroom') {
                ModuleActions.getEvents(this.state.moduleId, {limit: 0});
            }
        }
    }

    eventChange() {
        const events = ModuleEventStore.getByModule(this.state.module.id);
        if (!!events) {
            this.setState({events: events.map(this.convertEvent)});
        }
    }

    convertEvent({id, name, ...event}) {
        const start = new Date(event.eventStart || event.timeStart);
        const end = new Date(event.eventEnd || event.timeEnd);
        return {
            id,
            title: name,
            start,
            end,
            allDay: (start.toLocaleTimeString() === "00:00:00" && end.toLocaleTimeString() === "00:00:00"),
            url:   `/dashboard/event/${id}`,
            attendanceStatus: event.attendanceStatus,
            selectAction: () => this.selectEvent(id)
        };
    }

    selectEvent(eventId) {
        this.setState({selectedEvent: (!!eventId && ModuleEventStore.getEvent(this.state.module.id, eventId)) || null});
    }
}

ModuleCalendar.getStores = () => ([ModuleEventStore]);
ModuleCalendar.calculateState = (prevState) => {
    const moduleId = !!prevState && prevState.moduleId || null;
    return {
        ...prevState,
        module: (!!prevState && prevState.module) || {},
        events: prevState && prevState.events || [],
        selectEvent: prevState && prevState.selectedEvent || {}
    };
};
ModuleCalendar.contextTypes = {
    auth:       PropTypes.object
};
export default Container.create(ModuleCalendar);
